import PropTypes from 'prop-types';

const SeoReportSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 70}`}
      height={`${height || 70}`}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#clip0_637_8619${width + height})`}>
        <path
          d="M53.457 10.2539L49.3555 0H8.33984C7.19127 0 6.28906 0.902207 6.28906 2.05078V67.9492C6.28906 69.0975 7.19127 70 8.33984 70H61.6602C62.8087 70 63.7109 69.0975 63.7109 67.9492V14.3555L53.457 10.2539Z"
          fill={`url(#paint0_linear_637_8619${width + height})`}
        />
        <path
          d="M51.4062 14.3555H63.7109C63.7109 13.8223 63.5059 13.2889 63.0956 12.9198L50.7909 0.615098C50.4219 0.205078 49.8887 0 49.3555 0V12.3047C49.3555 13.4373 50.2737 14.3555 51.4062 14.3555ZM35 26.6602C35 25.5266 34.0828 24.6094 32.9492 24.6094H26.7969V18.457C26.7969 17.3235 25.8796 16.4062 24.7461 16.4062C19.0924 16.4062 14.4922 21.0064 14.4922 26.6602C14.4922 32.3139 19.0924 36.9141 24.7461 36.9141C30.3998 36.9141 35 32.3139 35 26.6602ZM32.9492 20.5078H41.1523C42.2859 20.5078 43.2031 19.5906 43.2031 18.457C43.2031 12.8033 38.6029 8.20312 32.9492 8.20312C31.8157 8.20312 30.8984 9.12037 30.8984 10.2539V18.457C30.8984 19.5906 31.8157 20.5078 32.9492 20.5078ZM53.457 24.6094H41.1523C40.0188 24.6094 39.1016 25.5266 39.1016 26.6602C39.1016 27.7937 40.0188 28.7109 41.1523 28.7109H53.457C54.5906 28.7109 55.5078 27.7937 55.5078 26.6602C55.5078 25.5266 54.5906 24.6094 53.457 24.6094ZM53.457 32.8125H41.1523C40.0188 32.8125 39.1016 33.7297 39.1016 34.8633C39.1016 35.9968 40.0188 36.9141 41.1523 36.9141H53.457C54.5906 36.9141 55.5078 35.9968 55.5078 34.8633C55.5078 33.7297 54.5906 32.8125 53.457 32.8125ZM53.457 57.5586H51.4062V43.2031C51.4062 42.0696 50.489 41.1523 49.3555 41.1523C48.2219 41.1523 47.3047 42.0696 47.3047 43.2031V57.5586H43.2031V47.3047C43.2031 46.1712 42.2859 45.2539 41.1523 45.2539C40.0188 45.2539 39.1016 46.1712 39.1016 47.3047V57.5586H35V51.4062C35 50.2727 34.0828 49.3555 32.9492 49.3555C31.8157 49.3555 30.8984 50.2727 30.8984 51.4062V57.5586H28.8477C27.7141 57.5586 26.7969 58.4758 26.7969 59.6094C26.7969 60.7429 27.7141 61.6602 28.8477 61.6602H53.457C54.5906 61.6602 55.5078 60.7429 55.5078 59.6094C55.5078 58.4758 54.5906 57.5586 53.457 57.5586ZM20.6445 41.1523H16.543C15.4094 41.1523 14.4922 42.0696 14.4922 43.2031C14.4922 44.3367 15.4094 45.2539 16.543 45.2539H20.6445C21.7781 45.2539 22.6953 44.3367 22.6953 43.2031C22.6953 42.0696 21.7781 41.1523 20.6445 41.1523ZM20.6445 49.3555H16.543C15.4094 49.3555 14.4922 50.2727 14.4922 51.4062C14.4922 52.5398 15.4094 53.457 16.543 53.457H20.6445C21.7781 53.457 22.6953 52.5398 22.6953 51.4062C22.6953 50.2727 21.7781 49.3555 20.6445 49.3555ZM20.6445 57.5586H16.543C15.4094 57.5586 14.4922 58.4758 14.4922 59.6094C14.4922 60.7429 15.4094 61.6602 16.543 61.6602H20.6445C21.7781 61.6602 22.6953 60.7429 22.6953 59.6094C22.6953 58.4758 21.7781 57.5586 20.6445 57.5586Z"
          fill={`url(#paint1_linear_637_8619${width + height})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_637_8619${width + height}`}
          x1="35"
          y1="70"
          x2="35"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_637_8619${width + height}`}
          x1="39.1016"
          y1="61.6602"
          x2="39.1016"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <clipPath id={`clip0_637_8619${width + height}`}>
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

SeoReportSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default SeoReportSvg;
